// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RatingsText/ratingsText.scss
// module id = 1419
// module chunks = 10